"use client";

import { Copy, Check, Terminal } from "lucide-react";
import { useState } from "react";
import { AnimateOnScroll } from "./index";

const INSTALL_COMMAND = "curl -fsSL https://specledger.io/install.sh | bash";

export function InstallBanner() {
  const [copied, setCopied] = useState(false);

  const copyCommand = async () => {
    await navigator.clipboard.writeText(INSTALL_COMMAND);
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };

  return (
    <section className="py-8 sm:py-10 md:py-12 bg-gradient-to-r from-primary to-accent relative overflow-hidden">
      {/* Background Pattern */}
      <div className="absolute inset-0 pointer-events-none">
        <div className="absolute top-0 left-1/4 w-1/2 h-full bg-[radial-gradient(circle,rgba(255,255,255,0.08)_0%,transparent_50%)]" />
        <div className="absolute top-0 right-1/4 w-1/2 h-full bg-[radial-gradient(circle,rgba(255,255,255,0.08)_0%,transparent_50%)]" />
      </div>

      <div className="max-w-[1200px] mx-auto px-4 sm:px-6 lg:px-8 relative">
        <AnimateOnScroll variant="fade-up">
          <div className="flex flex-col md:flex-row items-center justify-center gap-4 md:gap-6">
            <div className="flex items-center gap-3 text-white">
              <Terminal className="w-5 h-5 text-white/80" />
              <span className="text-sm sm:text-base font-medium">
                Install the CLI in seconds
              </span>
            </div>

            <div className="bg-white/15 backdrop-blur-lg border border-white/20 rounded-lg px-3 py-2 sm:px-4 sm:py-2.5 flex items-center gap-3 font-mono text-xs sm:text-sm text-white">
              <div className="flex items-center gap-2 overflow-x-auto scrollbar-thin">
                <span className="text-white/60 flex-shrink-0">$</span>
                <span className="whitespace-nowrap">{INSTALL_COMMAND}</span>
              </div>
              <button
                onClick={copyCommand}
                className="flex-shrink-0 p-1.5 hover:bg-white/10 rounded-md transition-colors"
                title="Copy to clipboard"
              >
                {copied ? (
                  <Check className="w-4 h-4 text-green-400" />
                ) : (
                  <Copy className="w-4 h-4 text-white/60 hover:text-white" />
                )}
              </button>
            </div>
          </div>
        </AnimateOnScroll>
      </div>
    </section>
  );
}
